var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");
lorem.supplemental = require("./supplemental");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/lorem/index.js
// module id = 2094
// module chunks = 2